import { ResponseError } from '@backstage/errors';




/**
 * Options for creating a todo client.
 *
 * @public
 */











/**
 * An implementation of the AgentApi that talks to the agent plugin backend.
 *
 * @public
 */
export class AgentClient  {
    discoveryApi;
    identityApi;

  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async getClusterByEnvParam(params) {
    const baseUrl = await this.discoveryApi.getBaseUrl('agent');
    const { token } = await this.identityApi.getCredentials();

    const { customerName, projectName, environmentName } = params;

    const res = await fetch(`${baseUrl}/cluster/${customerName}/${projectName}/${environmentName}`, {
      method: 'GET',
      headers: token ? {
        Authorization: `Bearer ${token}`,
      } : undefined
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();

    return data;
  }
}